import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, Space, Typography } from 'antd';
import { BarChartOutlined, RadarChartOutlined, ApartmentOutlined, AppstoreAddOutlined } from '@ant-design/icons';
import './Overview.scss';

const { Title, Paragraph } = Typography;

interface OverviewProps {
  isMobile?: boolean;
}

const Overview: React.FC<OverviewProps> = ({ isMobile }) => {
  const { t } = useTranslation();

  const mainServices = t('mainServices', { returnObjects: true }) as string[];
  const techServices = t('techServicesList', { returnObjects: true }) as string[];

  const icons = [
    <BarChartOutlined style={{ fontSize: '60px', color: '#1890ff' }} />,
    <RadarChartOutlined style={{ fontSize: '60px', color: '#52c41a' }} />,
    <ApartmentOutlined style={{ fontSize: '60px', color: '#faad14' }} />,
    <AppstoreAddOutlined style={{ fontSize: '60px', color: '#eb2f96' }} />,
  ];

  return (
    <div className="home-page-wrapper overview-wrapper">
      <div className="home-page overview-page">
        {/* Title Section */}
        <div className="title-wrapper" style={{ textAlign: 'center', marginBottom: '40px' }}>
          <Title level={2}>{t('servicesTitle')}</Title>
        </div>

        {/* Main Services Section */}
        <div className="main-services-section" style={{ marginBottom: '60px' }}>
          <Row gutter={[24, 24]} justify="center">
            {mainServices.map((service: string, index: number) => (
              <Col key={index} xs={24} sm={12} md={6}>
                <Card
                  hoverable
                  className="service-card"
                  style={{ 
                    textAlign: 'center', 
                    height: '100%',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    <div className="service-icon">
                      {icons[index]}
                    </div>
                    <Paragraph strong style={{ margin: 0 }}>
                      {service}
                    </Paragraph>
                  </Space>
                </Card>
              </Col>
            ))}
          </Row>
        </div>

        {/* Tech Services Section */}
        <div className="tech-services-wrapper" style={{ maxWidth: '800px', margin: '0 auto' }}>
          <Title level={3} style={{ textAlign: 'center', marginBottom: '30px' }}>
            {t('techServicesIntro')}
          </Title>
          
          <Card className="tech-services-card">
            <ul className="tech-services-list" style={{ 
              listStyle: 'none', 
              padding: 0,
              margin: 0
            }}>
              {techServices.map((service: string, index: number) => (
                <li 
                  key={index}
                  style={{
                    padding: '12px 20px',
                    borderBottom: index < techServices.length - 1 ? '1px solid #f0f0f0' : 'none',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                  className="tech-service-item"
                >
                  <Space>
                    <span style={{ color: '#1890ff', fontWeight: 'bold' }}>•</span>
                    <span>{service}</span>
                  </Space>
                </li>
              ))}
            </ul>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Overview;